import { DhbNavBar } from '@/component/PageComponentMobile/head'
import React from 'react'
import { useLocation,Location, useNavigationType } from 'react-router-dom'
import styled from "styled-components"


type TableDetailListItem = {label:string,value:string|number}


const CardView = styled.div`
  .card-content{
    background: linear-gradient(#0e55c3,#629ffb);
    border-radius: 6px;
    margin: 15px;
    padding: 15px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
  }
  .card-item{
    width: 50%;
    min-height: 70px;
    display: flex;
    color: #fff;
    flex-direction: column;
    padding: 7px;
    justify-content: flex-start;
    .value{
      font-size: 20px;
      font-weight: bold;
      word-break: break-all;
    }
  }
`


interface CardProps{
  list?:Array<TableDetailListItem>
}

const Card = (props:CardProps)=>{
  const {  list = [] } = props
  return <CardView>
    <div className='card-content'>
      {
        list.map((item,index)=>{
          return <div className='card-item' key={index}>
              <div>{item.label}</div>
              <div className='value'>{item.value}</div>
            </div>
        })
      }
    </div>
  </CardView>
}




const TableDetailView = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  .content{
    flex: 1;
    overflow-y: auto;
    padding-bottom: 15px;
  }
  .list{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 50%;
      /* width: 100%; */
      min-height: 70px;
      padding: 15px 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #fff;
      &:nth-child(4n+1),&:nth-child(4n+2){
        margin-top: 10px;
      }
      .value{
        font-size: 17px;
        font-weight: bold;
        word-break: break-all;
      }
    }
  }


`


export interface TableDetailProps {

}

type LocationState = {
  list?:Array<TableDetailListItem>
  card?:Array<TableDetailListItem>
  title?: string
}


const TableDetail = (props:TableDetailProps)=>{
  const location = useLocation() as Location<LocationState>

  const { list = [],card,title = '数据报表' } = location.state
  if(list.length % 2 == 1){
    list.push({
      label:'',
      value:''
    })
  }
  return <TableDetailView>
    <DhbNavBar
        title={ title }
      ></DhbNavBar>
    <div className='content'>
      <Card list={card} />
      <div className='list'>
        {list.map((item, index) => {
          return <div className='item' key={index}>
            <div className='lable'> {item.label} </div>
            <div className='value' > {item.value} </div>
          </div>
        })}
      </div>
    </div>
  </TableDetailView>
}

export default TableDetail